import React, { Component } from "react";
import { formatIsoDate } from "../../../helpers/formatters";

interface ComisionItem {
  fila: number;
  numeroEmpleado: string;
  empleado: string;
  club: string;
  conceptoInfo: string;
  montoComision: number;
  fechaPago: string;
  descripcion: string;
  resultado: "ERROR" | "WARNING" | "SUCCESS";
  mensaje: string;
}

interface Props {
  comisiones: ComisionItem[];
}

export default class CargaComisionesManualesTable extends Component<Props> {
  getRowStyle = (resultado: "ERROR" | "WARNING" | "SUCCESS") => {
    switch (resultado) {
      case "ERROR":
        return { backgroundColor: "#f8d7da" };
      case "WARNING":
        return { backgroundColor: "#fffbdbff" };
      case "SUCCESS":
        return { backgroundColor: "#d4edda" };
      default:
        return {};
    }
  };

  getDescripcion = (resultado: "ERROR" | "WARNING" | "SUCCESS") => {
    switch (resultado) {
      case "ERROR":
        return "Error";
      case "WARNING":
        return "Advertencia";
      case "SUCCESS":
        return "Correcto";
      default:
        return "Advertencia";
    }
  };

  formatCurrency = (amount: number) => {
    return new Intl.NumberFormat("es-MX", {
      style: "currency",
      currency: "MXN"
    }).format(amount);
  };

  render() {
    const { comisiones } = this.props;

    if (!comisiones || comisiones.length === 0) {
      return null;
    }

    const errores = comisiones.filter(r => r.resultado === "ERROR").length;

    return (
      <>
        <div className="mb-3">
          <div className="row">
            <div className="col-12">
              <p>
                Total de registros procesados: {comisiones.length} &nbsp; (
                {errores} erróneos)
              </p>
            </div>
          </div>

          <div className="row mt-1">
            <div className="col-12">
              <div className="table-responsive">
                <table className="table table-striped table-bordered table-sm">
                  <thead className="thead-dark">
                    <tr>
                      <th style={{ width: "32px", maxWidth: "32px" }}></th>
                      <th style={{ width: "128px", maxWidth: "128px" }}>
                        Club
                      </th>
                      <th style={{ width: "64px", maxWidth: "64px" }}>
                        No. Emp.
                      </th>
                      <th style={{ width: "256px", maxWidth: "256px" }}>
                        Empleado
                      </th>
                      <th style={{ width: "64px", maxWidth: "64px" }}>
                        C. Nom.
                      </th>
                      <th
                        style={{
                          width: "80px",
                          maxWidth: "80px",
                          textAlign: "center"
                        }}
                      >
                        Monto
                      </th>
                      <th
                        style={{
                          width: "96px",
                          maxWidth: "96px",
                          textAlign: "center"
                        }}
                      >
                        F. de Pago
                      </th>
                      <th style={{ width: "160px", maxWidth: "160px" }}>
                        Descripción
                      </th>
                      <th>Mensaje</th>
                    </tr>
                  </thead>
                  <tbody>
                    {comisiones.map((item, i) => (
                      <tr key={i} style={this.getRowStyle(item.resultado)}>
                        <td>{item.fila}</td>
                        <td>{item.club}</td>
                        <td>{item.numeroEmpleado}</td>
                        <td>
                          <div
                            style={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "240px"
                            }}
                          >
                            {item.empleado}
                          </div>
                        </td>
                        <td>{item.conceptoInfo}</td>
                        <td className="text-right">
                          {this.formatCurrency(item.montoComision)}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          {formatIsoDate(item.fechaPago)}
                        </td>
                        <td>
                          <div
                            style={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "144px"
                            }}
                          >
                            {item.descripcion}
                          </div>
                        </td>
                        <td>
                          {item.mensaje.split("\n").map((line, i) => (
                            <div key={i}>
                              {`${line == "Ok" ? "" : "- "}${line}`}
                            </div>
                          ))}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
